<template>
  <div class="main">
    <b-modal 
      hide-header 
      hide-footer 
      centered
      size="lg"
      v-model="modalShow">
      <AvisoModal @closeModal="modalShow = false" />
    </b-modal>
    <menu-bar-invest-vue />
    <tela-principal />
    <porque-investir-em-mato-grosso />
    <setores-para-investir />
    <IncentivosParaQuemInvesteEmMT />
    <!-- <MainEventos /> -->
    <!-- <QueDizerDeNos /> -->
    <TralhaConosco />
    <main-contato />
    <main-footer />
  </div>
</template>

<script>
import TelaPrincipal from "./views/TelaPrincipal.vue";
import MenuBarInvestVue from "./components/MenuBarInvest.vue";
import AvisoModal from "./components/AvisoModal.vue";
export default {
  name: "App",
  data: () => ({
    page: false,
    modalShow: false,
  }),
  components: {
      TelaPrincipal,
      AvisoModal,
    MainFooter: () =>
      import(/* webpackChunkName: "main-footer" */ "./views/MainFooter.vue"),
    PorqueInvestirEmMatoGrosso: () =>
      import(
        /* webpackChunkName: "porque-investir-em-mt" */ "./views/PorqueInvestirEmMatoGrosso.vue"
      ),
    MenuBarInvestVue,
    SetoresParaInvestir: () =>
      import(
        /* webpackChunkName: "setores-para-investir" */ "./views/SetoresParaInvestir.vue"
      ),
    IncentivosParaQuemInvesteEmMT: () =>
      import(
        /* webpackChunkName: "incentivos-para-quem-investe-em-mt" */ "./views/IncentivosParaQuemInvesteEmMT.vue"
      ),
    MainContato: () =>
      import(/* webpackChunkName: "main-contato" */ "./views/MainContato.vue"),
    TralhaConosco: () =>
      import(/* webpackChunkName: "trabalhe-conosco" */ "./views/TrabalheConosco.vue"),
  },
  methods: {
  },
};
</script>

<style>
@font-face {
  font-family: "Uni Neue";
  src: local("Uni Neue"),
    url(./assets/fonts/uni-neue/Fontfabric\ -\ UniNeueRegular.otf),
    url(./assets/fonts/uni-neue/Fontfabric\ -\ UniNeueBold.otf);
}

* {
  font-family: "Uni Neue";
}

.main {
  width: 100%;
  max-width: 100%;
  min-height: 200px;
}

html {
  scroll-behavior: smooth;
}

.teste {
  min-height: 200px;
}
</style>
